<template>
    <div class="w-full space-y-3">
        <Head title="BT Supplier Import"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">BT Supplier Import</h1>
        </div>
        <SlideOutErrors :show="showErrors === true"/>
    </div>
    <form @submit.prevent="submit">
        <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="col-span-2 w-1/4">
                            <div class="mt-1">
                                <label
                                    class="w-full mb-4 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                    <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 20 20">
                                        <path
                                            d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"/>
                                    </svg>
                                    <span v-if="form.file_uploads.length  === 0" class="mt-2 text-base leading-normal">Select BT Supplier's file to import</span>
                                    <span v-else>{{ form.file_uploads.length }} file<span
                                        v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                    <input type='file' class="hidden" @change="prepareFileUpload($event)"/>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6justify-end">
            <button :disabled="form.processing || !form.isDirty" type="submit"
                    class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                <span>Upload</span>
            </button>
        </div>
    </form>
    <div v-if="this.response && this.response.length">
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6 mt-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50 bg-red-300">
                                    <tr>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-900 uppercase tracking-wider">
                                            Message
                                        </th>
                                        <th scope="col"
                                            class="px-6 py-3 text-left text-xs text-gray-900 uppercase tracking-wider">
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="bg-red-300">
                                    <tr v-for="response in failedResponses" class="border-b border-gray-200">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ response.message }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {{ response.status.charAt(0).toUpperCase() + response.status.slice(1) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated";
import {Head, useForm, usePage} from "@inertiajs/vue3";
import {UploadIcon} from '@heroicons/vue/solid'
import {ref, computed} from "vue";
import SlideOutErrors from "@/Components/SlideOutErrors";

export default {
    layout: Authenticated,
    components: {
        Head,
        UploadIcon,
        SlideOutErrors
    },
    props: ['message', 'response'],
    setup(props) {
        const form = useForm({
            file_uploads: []
        });

        const showErrors = ref(false);

        return {
            form,
            showErrors
        }
    },
    methods: {
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        },
        submit() {

            this.form.post(route('frontend.bt-supplier-import.upload'), {
                onSuccess: response => {
                    this.showErrors = false;
                    this.form.reset();
                },
                onError: errors => {
                    this.showErrors = true;
                }
            });
        }
    },
    computed: {
        failedResponses() {
            return this.response.filter(item => item.status == 'failed');
        }
    }
}
</script>
